import React, { useState, useEffect } from 'react';
import { array, bool, func, object, string } from 'prop-types';

import { connect } from 'react-redux';

import { useFormik } from 'formik';
import * as Yup from 'yup';

import useApi from '../../../hooks/useApi';
import lambdaBaseApi from '../../../apis/lambda';

import { isEmpty } from 'lodash';

import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import template from 'url-template';

import TextArea from '../../../components/FormFields/TextArea';

import Button from '@material-ui/core/Button';
import BobConfirmButton from '../../../components/BobConfirmButton';

import * as ApplicationMessageActions from '../../../actions/applicationMessageActions';
import * as ServiceManagementActions from '../../../actions/serviceManagementActions';
import * as SvcRequestActions from '../../../actions/svcRequestActions';
import * as UiActions from '../../../actions/uiActions';

import classes from './ServiceRequestActionModal.module.css';

const IssueTypesUrl = template.parse('/issuetypes');

const ValidationSchema = Yup.object().shape({
    issueType:     Yup.string(),
    skillType:     Yup.string(),
    priority:      Yup.string(),
    skillLevel:    Yup.string(),
    duration:      Yup.number(),
    declineReason: Yup.string(),
    description:   Yup.string()
});

const DEFAULT_FORM_VALUES = {
    issueType:     '',
    skillType:     '',
    priority:      '',
    skillLevel:    '',
    duration:      '',
    declineReason: '',
    description:   ''
};

const InitialValues = {...DEFAULT_FORM_VALUES};

const formattedPriorities = [
    {
        id:   2,
        name: 'High'
    },
    {
        id:   1,
        name: 'Medium'
    },
    {
        id:   0,
        name: 'Low'
    }
];

const declineReason = [
    {
        id:   4,
        name: 'Reason 4'
    },
    {
        id:   3,
        name: 'Reason 3'
    },
    {
        id:   2,
        name: 'Reason 2'
    },
    {
        id:   1,
        name: 'Reason 1'
    },
    {
        id:   0,
        name: 'Others'
    }
];

const ServiceRequestActionModal = ({
    actionType,
    close,
    clearErrors,
    companyInfo,
    createSvcRequest,
    currentUser,
    errors,
    fetchServiceItemList,
    isLoading,
    isEdit,
    open,
    onClose,
    rule = null,
    selectedServiceRequest,
    seniorityLevels,
    specialties,
    title,
    toggleLoading,
    ...props
}) => {
    const [issueTypes, fetchIssueTypes] = useApi(() => ({
        url: IssueTypesUrl.expand()
    }), lambdaBaseApi);

    const [selectedAction, setSelectedAction] = useState(actionType);
    const [formattedIssueTypes, setFormattedIssueTypes] = useState([]);
    const [formattedSeniorityLevels, setFormattedSeniorityLevels] = useState([]);
    const [formattedSpecialties, setFormattedSpecialties] = useState([]);

    useEffect(() => {
        fetchIssueTypes();
    }, []);

    useEffect(() => {
        if (issueTypes.data) {
            const payload = issueTypes.data.map(issueType => {
                issueType.name = issueType.label;
                if (issueType.name === 'healthAndSafety') issueType.name = 'Health and Safety';

                return { id: issueType.id, name: issueType.name };
            });

            const formatted = payload;

            setFormattedIssueTypes(formatted);
        }
    }, [issueTypes]);

    useEffect(() => {
        if (!isEmpty(seniorityLevels)) {
            const payload = seniorityLevels.map(seniorityLevel => {
                return { id: seniorityLevel.id, name: seniorityLevel.label };
            });

            const formatted = payload;

            setFormattedSeniorityLevels(formatted);
        }
    }, [seniorityLevels]);

    useEffect(() => {
        if (!isEmpty(specialties) && !isEmpty(specialties[0].items)) {
            const payload = specialties[0].items.map(specialtie => {
                return { id: specialtie.id, name: specialtie.label };
            });

            const formatted = payload;

            setFormattedSpecialties(formatted);
        }
    }, [specialties]);

    const formik = useFormik({
        initialValues:      InitialValues,
        validationSchema:   ValidationSchema,
        enableReinitialize: true,
        onSubmit:           async (values, { setSubmitting }) => {

            const formatIssueTypes = (issueTypes) => {
                return issueTypes.map(type => type.id);
            };

            let body = {
                clientId:        values.client.id,
                clientContactId: values.clientContact.id,
                companyId:       companyInfo.companyId,
                summary:         values.summary,
                description:     values.description,
                issueTypes:      formatIssueTypes(values.issueTypes),
                priority:        values.priority.name,
                requesterEmail:  currentUser.email,
                requesterName:   currentUser.userName,
                requesterPhone:  currentUser.phone,
                siteId:          values.site.id,
                areaId:          values.area ? values.area.id : null
            };

            let isUpdated;

            if (!isLoading) {
                toggleLoading(true);
                isUpdated = await createSvcRequest(body);
            }

            if (isUpdated) {
                // handleClose();
            } else {
                toggleLoading(false);
            }
        }
    });

    const handleRadioChange = (event) => {
        event.preventDefault();
        
        if (event.target.value === 'Approve') {
            formik.setFieldValue('declineReason', '');
            formik.setFieldValue('description', '');
        }

        setSelectedAction(event.target.value);
    };   

    const requestDetails = isEmpty(selectedServiceRequest) ? null : selectedServiceRequest[0];
    
    return (
        <React.Fragment>
            <div className={classes.formColumn}>
                <div className={classes.labelColumn}>
                    <div className={classes.labelContent}>
                        <div>
                            <small>Target</small>
                            <p>{ requestDetails && requestDetails.target ? requestDetails.target : '' }</p>
                        </div>
                        <div>
                            <small>Client</small>
                            <p>{ requestDetails && requestDetails.client ? requestDetails.client : '' }</p>
                        </div>
                        <div>
                            <small>Site</small>
                            <p>{ requestDetails && requestDetails.site ? requestDetails.site : '' }</p>
                        </div>
                        <div>
                            <small>Faults</small>
                            { 
                                requestDetails && !isEmpty(requestDetails.faults) ?
                                    requestDetails.faults.map((item, id) => {
                                        return <p key={id}>{item}</p>;
                                    }) : ''
                            }
                        </div>
                        <div>
                            <small>Description</small>
                            <p>{ requestDetails && requestDetails.description ? requestDetails.description : '' }</p>
                        </div>
                    </div>
                </div>
                <div className={classes.formfields}>
                    <div className={classes.formRightColumn}>
                        <div className={classes.inputColumn}>
                            <div className={classes.inputs}>
                                <FormControl className={classes.inputWrapper}>
                                    <InputLabel
                                        htmlFor="issueType"
                                        classes={{
                                            error:   classes.error,
                                            focused: classes.labelFocused,
                                            root:    classes.label
                                        }}
                                        error={Boolean(formik.errors.issueType) && Boolean(formik.touched.issueType)}
                                    >
                                        Issue Type{ selectedAction === 'Decline' ? '' : <span className={classes.required}> *</span>}
                                    </InputLabel>
                                    <Select
                                        value={formik.values.issueType}
                                        onChange={ e => {
                                            formik.handleChange(e);
                                        }}
                                        className={classes.select}
                                        disabled={isEdit}
                                        inputProps={{
                                            name:   'issueType',
                                            id:     'issueType',
                                            onBlur: formik.handleBlur
                                        }}
                                        error={Boolean(formik.errors.issueType) && Boolean(formik.touched.issueType)}
                                    >
                                        {
                                            formattedIssueTypes.map(type =>
                                                <MenuItem
                                                    key={type.id}
                                                    value={type.id}
                                                >
                                                    {type.name}
                                                </MenuItem>
                                            )
                                        }
                                    </Select>
                                    {formik.touched.issueType &&
                                formik.errors.issueType && <FormHelperText className={classes.error}>{formik.errors.issueType}</FormHelperText>}
                                </FormControl>
                                <FormControl className={classes.inputWrapper}>
                                    <InputLabel
                                        htmlFor="skillType"
                                        classes={{
                                            error:   classes.error,
                                            focused: classes.labelFocused,
                                            root:    classes.label
                                        }}
                                        error={Boolean(formik.errors.skillType) && Boolean(formik.touched.skillType)}
                                    >
                                        Skill Type{ selectedAction === 'Decline' ? '' : <span className={classes.required}> *</span>}
                                    </InputLabel>
                                    <Select
                                        value={formik.values.skillType}
                                        onChange={ e => {
                                            formik.handleChange(e);
                                        }}
                                        className={classes.select}
                                        disabled={isEdit}
                                        inputProps={{
                                            name:   'skillType',
                                            id:     'skillType',
                                            onBlur: formik.handleBlur
                                        }}
                                        error={Boolean(formik.errors.skillType) && Boolean(formik.touched.skillType)}
                                    >
                                        {
                                            formattedSpecialties.map(type =>
                                                <MenuItem
                                                    key={type.id}
                                                    value={type.id}
                                                >
                                                    {type.name}
                                                </MenuItem>
                                            )
                                        }
                                    </Select>
                                    {formik.touched.skillType &&
                                formik.errors.skillType && <FormHelperText className={classes.error}>{formik.errors.skillType}</FormHelperText>}
                                </FormControl>
                                <FormControl className={classes.inputWrapper}>
                                    <TextField
                                        id="duration"
                                        name="duration"
                                        type="number"
                                        value={formik.valuesduration}
                                        label={<span>Duration(Hrs){ selectedAction === 'Decline' ? '' : <span className={classes.required}> *</span>}</span>}
                                        onChange={formik.handleChange}
                                        InputLabelProps={{
                                            classes: {
                                                error:   classes.error,
                                                focused: classes.labelFocused,
                                                root:    classes.label
                                            }
                                        }}
                                        InputProps={{
                                            onBlur:  formik.handleBlur,
                                            classes: {
                                                error:     classes.cssErrorUnderline,
                                                underline: classes.cssUnderline,
                                                root:      classes.input
                                            }
                                        }}
                                        FormHelperTextProps={{
                                            classes: {
                                                error: classes.error
                                            }
                                        }}
                                        error={Boolean(formik.errorsduration) && Boolean(formik.touchedduration)}
                                        helperText={Boolean(formik.touchedduration) && formik.errorsduration}
                                    />
                                </FormControl>
                            </div>
                        </div>
                        <div className={classes.inputColumn}>
                            <div className={classes.inputs}>
                                <FormControl className={classes.inputWrapper}>
                                    <InputLabel
                                        htmlFor="priority"
                                        classes={{
                                            error:   classes.error,
                                            focused: classes.labelFocused,
                                            root:    classes.label
                                        }}
                                        error={Boolean(formik.errors.priority) && Boolean(formik.touched.priority)}
                                    >
                                        Priority{ selectedAction === 'Decline' ? '' : <span className={classes.required}> *</span> }
                                    </InputLabel>
                                    <Select
                                        value={formik.values.priority}
                                        onChange={ e => {
                                            formik.handleChange(e);
                                        }}
                                        className={classes.select}
                                        disabled={isEdit}
                                        inputProps={{
                                            name:   'priority',
                                            id:     'priority',
                                            onBlur: formik.handleBlur
                                        }}
                                        error={Boolean(formik.errors.priority) && Boolean(formik.touched.priority)}
                                    >
                                        {
                                            formattedPriorities.map(type =>
                                                <MenuItem
                                                    key={type.id}
                                                    value={type.id}
                                                >
                                                    {type.name}
                                                </MenuItem>
                                            )
                                        }
                                    </Select>
                                    {formik.touched.priority &&
                                formik.errors.priority && <FormHelperText className={classes.error}>{formik.errors.priority}</FormHelperText>}
                                </FormControl>
                                <FormControl className={classes.inputWrapper}>
                                    <InputLabel
                                        htmlFor="skillLevel"
                                        classes={{
                                            error:   classes.error,
                                            focused: classes.labelFocused,
                                            root:    classes.label
                                        }}
                                        error={Boolean(formik.errors.skillLevel) && Boolean(formik.touched.skillLevel)}
                                    >
                                        Skill Level{ selectedAction === 'Decline' ? '' : <span className={classes.required}> *</span> }
                                    </InputLabel>
                                    <Select
                                        value={formik.values.skillLevel}
                                        onChange={ e => {
                                            formik.handleChange(e);
                                        }}
                                        className={classes.select}
                                        disabled={isEdit}
                                        inputProps={{
                                            name:   'skillLevel',
                                            id:     'skillLevel',
                                            onBlur: formik.handleBlur
                                        }}
                                        error={Boolean(formik.errors.skillLevel) && Boolean(formik.touched.skillLevel)}
                                    >
                                        {
                                            formattedSeniorityLevels.map(type =>
                                                <MenuItem
                                                    key={type.id}
                                                    value={type.id}
                                                >
                                                    {type.name}
                                                </MenuItem>
                                            )
                                        }
                                    </Select>
                                    {formik.touched.skillLevel &&
                                formik.errors.skillLevel && <FormHelperText className={classes.error}>{formik.errors.skillLevel}</FormHelperText>}
                                </FormControl>
                            </div>
                        </div>
                    </div>
                    <div className={classes.formDeclineSection}>
                        <FormControl component="fieldset" className={classes.formControl}>
                            <RadioGroup
                                row aria-label="action" name="action"
                                value={selectedAction}
                                onChange={(e) => handleRadioChange(e)}
                            >
                                <FormControlLabel
                                    className={classes.firstRadioLabel}
                                    value={'Approve'} control={<Radio />} label="Approve"
                                    labelPlacement="start"
                                />
                                <FormControlLabel
                                    value={'Decline'} control={<Radio />} label="Decline"
                                    labelPlacement="start"
                                />
                            </RadioGroup>
                        </FormControl>
                        {
                            selectedAction === 'Decline' ?
                                <FormControl className={classes.inputWrapper}>
                                    <InputLabel
                                        htmlFor="declineReason"
                                        classes={{
                                            error:   classes.error,
                                            focused: classes.labelFocused,
                                            root:    classes.label
                                        }}
                                        error={Boolean(formik.errors.declineReason) && Boolean(formik.touched.declineReason)}
                                    >
                                        Decline Reason<span className={classes.required}> *</span>
                                    </InputLabel>
                                    <Select
                                        value={formik.values.declineReason}
                                        onChange={ e => {
                                            formik.handleChange(e);
                                        }}
                                        className={classes.select}
                                        disabled={isEdit}
                                        inputProps={{
                                            name:   'declineReason',
                                            id:     'declineReason',
                                            onBlur: formik.handleBlur
                                        }}
                                        error={Boolean(formik.errors.declineReason) && Boolean(formik.touched.declineReason)}
                                    >
                                        {
                                            declineReason.map(type =>
                                                <MenuItem
                                                    key={type.id}
                                                    value={type.id}
                                                >
                                                    {type.name}
                                                </MenuItem>
                                            )
                                        }
                                    </Select>
                                    {formik.touched.declineReason &&
                                        formik.errors.declineReason && <FormHelperText className={classes.error}>{formik.errors.declineReason}</FormHelperText>}
                                </FormControl> 
                                : '' 
                        }
                        {
                            formik.values.declineReason === 0 ?
                                <FormControl className={classes.inputWrapper}>
                                    <TextArea
                                        name="description"
                                        type="text"
                                        multiline={true}
                                        value={formik.values.description}
                                        label={<span>Reason for Cancelling<span className={classes.required}> *</span></span>}
                                        onChange={formik.handleChange}
                                        InputLabelProps={{
                                            classes: {
                                                error:   classes.error,
                                                focused: classes.labelFocused,
                                                root:    classes.label
                                            }
                                        }}
                                        InputProps={{
                                            onBlur:  formik.handleBlur,
                                            classes: {
                                                error: classes.cssErrorUnderline,
                                                root:  classes.summaryTextArea
                                            }
                                        }}
                                        FormHelperTextProps={{
                                            classes: {
                                                error: classes.error
                                            }
                                        }}
                                        error={Boolean(formik.errors.description) && Boolean(formik.touched.description)}
                                        helperText={Boolean(formik.touched.description) && formik.errors.description}
                                    />
                                </FormControl>
                                : ''
                        }                  
                    </div>
                </div>
            </div>
            <React.Fragment>
                <Button
                    className={classes.Button}
                    onClick={onClose}
                    variant="contained"
                >
                    Cancel
                </Button>
                <BobConfirmButton
                    className={classes.ButtonWithMargin}
                    disabled={formik.isSubmitting || isLoading}
                    isLoading={isLoading}
                    label={'Apply'}
                    onClick={formik.handleSubmit}
                />
            </React.Fragment>
        </React.Fragment>
    );
};

ServiceRequestActionModal.defaultProps = {
    close:       () => {},
    companyInfo: {},
    currentUser: {},
    errors:      [],
    isLoading:   false,
    open:        false,
    rule:        {},
    title:       ''
};

ServiceRequestActionModal.propTypes = {
    close:       func,
    companyInfo: object,
    currentUser: object,
    errors:      array,
    isLoading:   bool,
    open:        bool,
    rule:        object,
    title:       string
};

const mapStateToProps = state => {
    return {
        companyInfo:     state.companyInfo,
        currentUser:     state.currentUser,
        errors:          state.messages.errors,
        isLoading:       state.ui.isLoading,
        seniorityLevels: state.architect.seniorityLevels,
        specialties:     state.architect.specialties
    };
};

const mapDispatchToProps = {
    ...ApplicationMessageActions,
    ...ServiceManagementActions,
    ...SvcRequestActions,
    ...UiActions
};

export default connect(mapStateToProps, mapDispatchToProps)(ServiceRequestActionModal);
